<p id="title" class="headline-small">{{ data.title | translate:data.titleParams }} </p>
<mat-dialog-content id="content">
  <span class="body-medium">{{ data.message | translate }}</span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ data.cancelButtonText | translate }}</button>
  <button mat-flat-button [mat-dialog-close]="true" cdkFocusInitial>{{ data.confirmButtonText | translate }}</button>
</mat-dialog-actions>
